<script setup lang="ts">
import type { Canvass, CanvassHouse } from "@/canvasses/types";
import CommentsDashboard from "@/comments/CommentsDashboard.vue";
import {
  useCreateHouseComment,
  useDeleteHouseComment,
  useGetHouseComments,
  useUpdateHouseComment,
} from "@/comments/useHouseComments";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";

const props = defineProps<{
  canvassHouse: CanvassHouse;
  canvass: Canvass; // suppress router warnings
}>();

const { comments, getHouseCommentsStatus } = useGetHouseComments(
  props.canvassHouse.id,
);
const {
  createComment,
  createHouseCommentStatus,
  error: createHouseCommentError,
} = useCreateHouseComment(props.canvassHouse.id);
const { updateComment } = useUpdateHouseComment(props.canvassHouse.id);
const {
  deleteComment,
  deleteHouseCommentStatus,
  reset: resetDeleteHouseComment,
} = useDeleteHouseComment(props.canvassHouse.id);
</script>

<template>
  <div class="container container-md">
    <HandleQueryStatus :query-status="getHouseCommentsStatus">
      <CommentsDashboard
        :comments="comments"
        :creating-status="createHouseCommentStatus"
        :creating-error="createHouseCommentError"
        :deleting-status="deleteHouseCommentStatus"
        @create="createComment"
        @update="updateComment"
        @delete="deleteComment"
        @initiate-delete="resetDeleteHouseComment"
      />
    </HandleQueryStatus>
  </div>
</template>
